import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSupplierData } from "../../../../Redux/Selectors/appConfigSelector";
import { getBundlesData } from "../../../QuotePage/redux/QuoteSelectors";
import { clickEvents, trackEvent } from "../../../../services/mixpanel";
import { COMBO } from "../../../ShopPage/constants";

const BundleContainerQuote = ({ children }) => {
  const bundles = useSelector(getBundlesData);
  const supplierData = useSelector(getSupplierData);
  const [modalVisible, setModalVisible] = useState({
    visible: false,
    type: null,
    selectedBundle: null,
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const bundleId = params.get("bundle");

    if (bundleId) {
      const selectedBundle = bundles.find((bundle) => bundle._id === bundleId);
      if (selectedBundle) {
        openProductModal(COMBO, selectedBundle);
      }
    }
  }, []);

  const trackCategorySelection = (category, selectedBundle) => {
    trackEvent(clickEvents.SELECT_CATEGORY, {
      page: "Quote",
      category: category,
      supplierId: supplierData._id,
      supplierName: supplierData.name,
      selectedBundle,
    });
  };

  const openProductModal = (category, selectedBundle) => {
    setModalVisible({ visible: true, type: category, selectedBundle });
  };

  const handleOnClick = (category, selectedBundle) => {
    trackCategorySelection(category, selectedBundle);
    openProductModal(category, selectedBundle);
  };

  return children({
    bundles,
    modalVisible,
    handleOnClick,
    setModalVisible,
  });
};

export default BundleContainerQuote;
